var map = {
	"./CM1有效载荷指标.jpg": 1051,
	"./DQ1有效载荷指标.jpg": 1052,
	"./GF3CGF3B成像模式.jpg": 1053,
	"./GF5B有效载荷指标.png": 1054,
	"./HJ-2E成像模式.jpg": 1055,
	"./LT1A1B成像模式.jpg": 1056,
	"./backearth.png": 1057,
	"./background-1.png": 1058,
	"./ball.png": 1059,
	"./decorativeThread.png": 1060,
	"./dot.png": 1061,
	"./icon-algorithm.png": 1062,
	"./icon-tools.png": 1063,
	"./img 2.png": 1064,
	"./img 3.png": 1065,
	"./img 4.png": 1066,
	"./map.png": 1067,
	"./sample.png": 1068,
	"./satellite.png": 1069,
	"./中巴地球资源卫星01星.png": 1070,
	"./中巴地球资源卫星04A星.png": 1071,
	"./中巴地球资源卫星04星.png": 1072,
	"./实践九号A星.png": 1073,
	"./实践九号B星.png": 1074,
	"./张衡一号.png": 1075,
	"./环境减灾一号.png": 1076,
	"./环境减灾一号C星.png": 1077,
	"./环境减灾二号.png": 1078,
	"./资源一号02C星.png": 1079,
	"./资源一号02D卫星.png": 1080,
	"./资源三号卫星.png": 1081,
	"./高分一号02星.png": 1082,
	"./高分七号卫星.png": 1083,
	"./高分三号卫星.png": 1084,
	"./高分三号卫星成像模式和能力表.png": 1085,
	"./高分二号卫星.png": 1086,
	"./高分五号卫星.png": 1087,
	"./高分五号卫星载荷及配置表.png": 1088,
	"./高分六号卫星.png": 1089,
	"./高分四号卫星.png": 1090,
	"./高分多模卫星.png": 1091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 584;